export default "__VITE_ASSET__DVGw7vfC__"